export enum FloorPlanTableType {
  RECT = "RECT",
  ROUND = "ROUND",
  CHAIR = "CHAIR",
}
